import React, { Component } from 'react'

export class TopHamburgerSvg extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width={26}
                height={26}
                fill="none"
            >
                <path
                    fill="#000"
                    d="M25.046 23.33a1.127 1.127 0 0 1-1.592 1.59L13 14.466 2.546 24.922a1.126 1.126 0 1 1-1.592-1.592l11.25-11.25a1.125 1.125 0 0 1 1.592 0l11.25 11.25Zm-22.5-9.66L13 3.216l10.454 10.456a1.123 1.123 0 0 0 1.592 0 1.127 1.127 0 0 0 0-1.592L13.796.83a1.125 1.125 0 0 0-1.592 0L.954 12.08a1.126 1.126 0 1 0 1.592 1.592Z"
                />
            </svg>
        )
    }
}

export default TopHamburgerSvg